import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home1',
    component: Home,
  },
  {
    path: '/:lang',
    name: 'home2',
    component: Home,
  },
  {
    path: '/:lang/cop29',
    name: 'cop29',
    component: () => import(/* webpackChunkName: "cop29" */ '../views/Cop29.vue'),
  },
  {
    path: '/:lang/maintenance',
    name: 'maintenance',
    component: () => import(/* webpackChunkName: "maintenance" */ '../views/Maintenance.vue'),
  },
  {
    path: '/:lang/search',
    name: 'search',
    component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue'),
  },
  {
    path: '/:lang/author/:code',
    name: 'author',
    component: () => import(/* webpackChunkName: "author" */ '../views/Author.vue'),
  },
  {
    path: '/:lang/invitation/:code',
    name: 'invitation',
    component: () => import(/* webpackChunkName: "invitation" */ '../views/Invitation.vue'),
  },
  {
    path: '/:lang/content/read/:code',
    name: 'read',
    component: () => import(/* webpackChunkName: "read" */ '../views/Read.vue'),
  },
  {
    path: '/:lang/subscribe/verify/:token',
    name: 'verifySubscribe',
    component: () => import(/* webpackChunkName: "verifySubscribe" */ '../views/VerifySubscribe.vue'),
  },
  {
    path: '/:lang/page/preview/:code/:sign',
    name: 'pagePreview',
    component: () => import(/* webpackChunkName: "pagePreview" */ '../views/PagePreview.vue'),
  },
  {
    path: '/:lang/:m1',
    name: 'page1',
    component: () => import(/* webpackChunkName: "page1" */ '../views/Page.vue'),
  },
  {
    path: '/:lang/:m1/:read/:code',
    name: 'page2',
    component: () => import(/* webpackChunkName: "page2" */ '../views/Page.vue'),
  },
  {
    path: '/:lang/:m1/:sm1/:m2/:read/:code',
    name: 'page3',
    component: () => import(/* webpackChunkName: "page3" */ '../views/Page.vue'),
  },
  {
    path: '/:lang/:m1/:sm1/:m2/:sm2/:m3/:read/:code',
    name: 'page4',
    component: () => import(/* webpackChunkName: "page4" */ '../views/Page.vue'),
  },
  // {
  //   path: '/subscribe/verify/:token',
  //   name: 'verifySubscribe',
  //   component: () => import(/* webpackChunkName: "verifySubscribe" */ '../views/VerifySubscribe.vue'),
  // },
  {
    path: '/:lang/*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "notFound" */ '../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const { app }: any = router;
  const r = await app.$http.get(app.$config.uri('config/item/underMaintenance'));
  const underMaintenance = r.data && r.data.status === 200 && r.data.data === 1;

  let { lang } = to.params;
  if (!lang || !['en-us', 'id-id'].includes(lang)) {
    if (lang) {
      const pathArr = to.path.substring(1, to.path.length - 1).split('/');
      let toPath = '';
      if (pathArr.length > 0) {
        if (pathArr[0] === 'kebijakan-privasi') {
          toPath = '/id-id/content/read/kebijakan-privasi';
        } else if (pathArr.length === 1) {
          const rd = await app.$http.post(app.$config.uri('misc/search'), {
            q: pathArr[0].replace(/-/g, ' '),
            lang: 'id',
          });
          if (rd.data.status === 200 && rd.data.data.length > 0) {
            toPath = `/id-id${rd.data.data[0].uri}`;
          }
        } else if (pathArr[0] === 'tag') {
          toPath = `/id-id/search?q=${pathArr[1]}`;
        } else if (pathArr[0] === 'dewan') {
          const rd = await app.$http.post(app.$config.uri('misc/search'), {
            q: pathArr[1].replace(/-/g, ' '),
            lang: 'id',
          });
          if (rd.data.status === 200 && rd.data.data.length > 0) {
            toPath = `/id-id${rd.data.data[0].uri}`;
          }
        } else if (pathArr[0] === 'author') {
          toPath = '/id-id/author/admin';
        } else {
          let q = '';
          if (pathArr[1] && pathArr[1] === 'page') {
            q = pathArr[0].replace(/-/g, ' ');
          } else if (pathArr[3]) {
            q = pathArr[3].replace(/-/g, ' ');
          } else {
            q = pathArr[1].replace(/-/g, ' ');
          }
          const rd = await app.$http.post(app.$config.uri('misc/search'), {
            q,
            lang: 'id',
          });
          if (rd.data.status === 200 && rd.data.data.length > 0) {
            toPath = `/id-id${rd.data.data[0].uri}`;
          }
          if (!toPath && pathArr[3]) {
            const rd2 = await app.$http.post(app.$config.uri('misc/search'), {
              q: pathArr[1].replace(/-/g, ' '),
              lang: 'id',
            });
            if (rd2.data.status === 200 && rd2.data.data.length > 0) {
              toPath = `/id-id${rd2.data.data[0].uri}`;
            }
          }
        }
      }
      if (toPath) next({ path: toPath });
      else next({ path: '/' });
      return;
    }
    let langCode = (window.navigator as any).userLanguage || window.navigator.language;
    langCode = (langCode === 'id-ID') ? 'id' : 'en';
    const countryCode = (langCode === 'id') ? 'id' : 'us';
    lang = `${langCode}-${countryCode}`;
  }

  /**
   * Redirect to home if page is under maintenance
   * but maintenance mode is off
   *
   */
  if (to.path.indexOf('/maintenance') >= 0 && !underMaintenance) {
    next({ path: `/${lang}` });
    return;
  }

  /**
   * Check for maintenance mode
   * if this not maintenance page
   *
   */
  if (to.path.indexOf('/maintenance') < 0 && underMaintenance) {
    next({ path: `/${lang}/maintenance` });
    return;
  }

  /**
   * Detect is url contain language code
   *
   */
  const re = /^\/[a-z]+-[a-z]+\/?/;
  let { path } = to;
  if (path.indexOf('/') === 0) path = path.substring(1);
  if (to.path !== '/' && !['en-us', 'id-id'].includes(path.split('/')[0])) {
    next({ path: '/' });
  } else {
    next();
  }
});

export default router;
